interface PlayerNameProps {
  name: string
}

export default function PlayerName(props: PlayerNameProps) {
  const { name } = props

  return <span>{name.trim().length === 0 ? "???" : name}</span>
}
